export const HB_BOARD_API =
	"https://api.hootboard.com/api/v2/public/boards?start=0&max=0&addBoardPosts=false&upcomingEvents=false&freeEvents=false&showFeaturedCollection=false&showScheduledHoots=false&customURL=";
export const HB_WP_API = "/wp-json/hootboard/v1/";
